module.exports = __webpack_public_path__ + "static/media/directions.a07769a3.png";